// extracted by mini-css-extract-plugin
export default {"dropDown":"AddLayerDropdown_dropDown__ByoKl","icon":"AddLayerDropdown_icon__A2WNt"};